import type { SVGProps } from "react";

export const Header = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={16}
      height={16}
      {...props}
    >
      <title id="5lCqiD7oLhCAShm2NLuTF-title">Header</title>
      <desc id="5lCqiD7oLhCAShm2NLuTF-description">Header blocks</desc>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 4v16s0 2 2 2h18c2 0 2-2 2-2V4c0-2-2-2-2-2H3S1 2 1 4zm20 15a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h16a1 1 0 011 1v10zM4 6a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M19 12a1 1 0 01-1 1H6a1 1 0 01-1-1v-1a1 1 0 011-1h12a1 1 0 011 1v1z"
        opacity="0.72"
      ></path>
    </svg>
  );
};
